export class SatelliteHandler {
  constructor (map, options) {
    this._map = map;
    this._options = {...this._options, ...options};
    this._sat_urls_dict = {};
    this._visible = false;
    this._layers = {};
    this._current_zoom_level = -1;
    this._largest_zoom_level = -1

    var self = this;
    this._map.on("resize", (e)=>{self.reset(e)} );
    this._map.on("viewreset ", (e)=>{self.reset(e)} );
    this._map.on("move", (e)=>{self.reset(e)} );
    this._map.on("moveend", (e)=>{self.reset(e)} );
    this._map.on("zoomend ", (e)=>{self.reset(e)} );
  }

  update (sat_data) {
    /*
    sat_data = [{urls_and_info}, ...]
    urls_and_info = {
      zoom: int,
      urls: list, containing a list of sat image uri
      dtime: str
    }
    */
    for (let key in this._layers) {
      this._layers[key].setOpacity(0)
    }
    this._sat_urls_dict = {};

    if (sat_data) {
      // find the largest zoom
      let sat_urls_list = []
      this._largest_zoom_level = -1
      for (let i = 0; i < sat_data.length; i++) {
        this._sat_urls_dict[sat_data[i].zoom] = sat_data[i].urls
        sat_urls_list = sat_urls_list.concat(sat_data[i].urls)
        if (sat_data[i]['zoom'] > this._largest_zoom_level) {
          this._largest_zoom_level = sat_data[i]['zoom']
        }
      }

      // Prepare imageOverlay layer from the prepared data
      for (let url of sat_urls_list) {
        let bounds = get_file_bounds(url)
        let img_url = process.env.WD_SERVER_HOST + url
        let ly_key = this.parse_layer_key(url)
        let layer = this._layers[ly_key]
        if (!layer) {
          layer = L.imageOverlay(img_url, bounds, this._options)
          this._layers[ly_key] = layer
        }
        else {
          layer.setUrl(img_url)
          layer.setBounds(bounds)
        }
        layer.setOpacity(1)
      }
    }
    this.reset();
  }

  set_visible(visible) {
    this._visible = visible;
    this.reset();
  }

  add_or_remove_layer(satellite_urls, force_remove) {
    if (!satellite_urls) {
      return
    }

    let viewbbs = this._map.getBounds();

    for (let url of satellite_urls) {
      let bounds = get_file_bounds(url);
      let ly_key = this.parse_layer_key(url);
      let layer = this._layers[ly_key];
      if (layer) {
        if (force_remove) {
          this._map.removeLayer(layer);
        }
        else if (this._visible) {
          if (viewbbs.intersects(bounds)) {
            this._map.addLayer(layer);
          }
          else {
            this._map.removeLayer(layer);
          }
        }
        else {
          this._map.removeLayer(layer);
          layer = null;
        }
      }
    }
  }

  convert_zoom_level(leaftlet_zoom_level) {
    // convert leaflet zoom level to satellite zoom level
    let satellite_zoom_level = leaftlet_zoom_level > 3 ? leaftlet_zoom_level - 3 : 0
    if (satellite_zoom_level > this._largest_zoom_level) {
      satellite_zoom_level = this._largest_zoom_level
    }
    return satellite_zoom_level
  }

  reset(e) {
    if (this._largest_zoom_level < 0) {
      return
    }
    let satellite_zoom_level = this.convert_zoom_level(this._map.getZoom())

    // remove old zoom level satellite image
    if (satellite_zoom_level != this._current_zoom_level) {
      if (this._current_zoom_level in this._sat_urls_dict) {
        this.add_or_remove_layer(this._sat_urls_dict[this._current_zoom_level], true)
      }
    }

    // add or remove for new zoom level
    this.add_or_remove_layer(this._sat_urls_dict[satellite_zoom_level])

    this._current_zoom_level = satellite_zoom_level
  }

  remove_layer() {
    for (let key in this._layers) {
      let layer = this._layers[key]
      this._map.removeLayer(layer);
    }
  }

  parse_layer_key(url_key) {
    let ly_keys = url_key.split("/")
    if (url_key.charAt(url_key.length-1) == "/") {
        return ly_keys[ly_keys.length-4]+":"+ly_keys[ly_keys.length-3]+":"+ly_keys[ly_keys.length-2];
    }
    return ly_keys[ly_keys.length-3]+":"+ly_keys[ly_keys.length-2]+":"+ly_keys[ly_keys.length-1];
  }

}


const get_file_bounds = (url) => {
  try {
    let filename_regex = new RegExp(/[\d.,]+(?=\.png)/)
    let filename = url.match(filename_regex)[0]

    let latlon_box = filename.split(',')
    let corner1 = L.latLng(latlon_box[1], latlon_box[3])
    let corner2 = L.latLng(latlon_box[0], latlon_box[2])
    let bounds = L.latLngBounds(corner1, corner2)

    return bounds
  } catch(e) {
    console.error(e)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/satellite.js